import * as api from "./api";

export const GET_ALL_ORGANIZATION_MEMBERS = "magnifi/organization-member/GET_ALL_ORGANIZATION_MEMBERS";
export const UPDATE_ORGANIZATION_MEMBER = "magnifi/organization-member/UPDATE_ORGANIZATION_MEMBER";
export const REMOVE_ORGANIZATION_MEMBER = "magnifi/organization-member/UPDATE_ORGANIZATION_MEMBER";

export const getAllOrganizationMembers = () => {
  return {
    type: GET_ALL_ORGANIZATION_MEMBERS,
    payload: api.getAllOrganizationMembers(),
  };
};

export const updateOrganizationMember = (data) => {
  return {
    type: UPDATE_ORGANIZATION_MEMBER,
    payload: api.updateOrganizationMember(data),
  };
};

export const removeOrganizationMember = (data) => {
  return {
    type: REMOVE_ORGANIZATION_MEMBER,
    payload: api.removeOrganizationMember(data),
  };
};
